<template>
    <div v-if="aboutPage" class="about">
        <page-cover
            v-if="aboutPage.Cover"
            :img="aboutPage.Cover.Image?.url ?? ''"
            :title="aboutPage.Cover.Title"
            :sub-title="aboutPage.Cover.Subtitle"
        />
        <div v-if="aboutPage.Other_Information.length > 0">
            <div
                v-for="(info, index) in aboutPage.Other_Information"
                :key="index"
            >
                <section v-if="index % 2 === 0">
                    <div
                        class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
                    >
                        <image-block
                            :title="info.Title"
                            :image-url="info.Image?.url ?? ''"
                            :description="info.Description"
                            :link-url="info.LinkUrl"
                            :link-text="info.LinkText"
                            :flip="false"
                        />
                    </div>
                </section>
                <section v-if="index % 2 === 1" class="section-bg">
                    <div
                        class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
                    >
                        <image-block
                            :title="info.Title"
                            :image-url="info.Image?.url ?? ''"
                            :description="info.Description"
                            :link-url="info.LinkUrl"
                            :link-text="info.LinkText"
                            :flip="true"
                        />
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script setup>
const config = useRuntimeConfig();
const { data: aboutPage } = await useFetch(config.public.baseURl + '/about-us');
useHead({
    title: 'About Us',
});
</script>

<style lang="scss" scoped>
.about {
}
</style>
